import http from './http.js'
import getOs from './getOs.js'
import native from './native.js'

const T = {
    http,
    os: getOs(),
    native
}


export default T